import UserTable from "../../components/Table/User/UserTable";
import { useLogs, useItems, ItemProps } from "../../hooks/useFetch";
import Table from "../../layouts/Table";
import { useMemo } from "react";
import { ILog } from "../../types/logType";
import { IUser } from "../../types/userType";
import { OutletType } from "admin/src/types";

const UserStatus = ({context}: OutletType<IUser>) => {
  const opts = useMemo<Partial<ItemProps>>(() => {
    return { type: "user", all: false };
  }, []);

  const chatOps = useMemo<Partial<ILog>>(() => {
    return { action: "chat", target: context._id };
  }, [context]);
  const [chatLogs] = useLogs(chatOps, 5);
  const [chated, , load] = useItems<IUser>(chatLogs, opts);

  const likeOps = useMemo<Partial<ILog>>(() => {
    return { action: "like", target: context._id };
  }, [context]);

  const [likeLogs] = useLogs(likeOps, 5);
  const [liked, , loads] = useItems<IUser>(likeLogs, opts);

  const viewOps = useMemo<Partial<ILog>>(() => {
    return { action: "page", target: context._id };
  }, [context]);

  const [viewLogs] = useLogs(viewOps, 5);
  const [viewed, , loading] = useItems<IUser>(viewLogs, opts);

  return (
    <div className="relative grid gap-y-10">
      <Table
        title="Chats"
        icon="fas fa-comment-dots"
        iconColor="text-emerald-500"
        loading={load}
      >
        <UserTable data={chated}></UserTable>
      </Table>
      <Table
        title="Likes"
        icon="fas fa-heart"
        iconColor="text-red-500"
        loading={loads}
      >
        <UserTable data={liked}></UserTable>
      </Table>
      <Table
        title="Views"
        icon="fas fa-eye"
        iconColor="text-purple-500"
        loading={loading}
      >
        <UserTable data={viewed}></UserTable>
      </Table>
    </div>
  );
};

export default UserStatus;
